export class BlogListCategory {
  public static investingInFDMoney = 'Investing in Fixed income';
  public static aSipFinancial = 'A SIP of financial freedom';
  public static financialPlanningOfSuccess = 'Financial Planning for Success';
  public static investingInEquity = 'Investing in Equity';
  public static planningYourRetirement = 'Planning your Retirement';
  public static forTheLoveOfMoney = 'For the Love of Money';
}
